import { Badge } from '@/components/ui/badge';
import type { PortalStatus } from '../status';

export function PortalStatusBadge({ status, className }: { status: PortalStatus; className?: string }) {
  return (
    <Badge variant={status.variant} className={className}>
      {status.label}
    </Badge>
  );
}
